module.exports = __webpack_public_path__ + "static/media/danger-info-icon.2a7eae89.svg";